import React, { createContext, ReactNode } from "react";
import { useGetAllFeatureFlagsQuery } from "../../types/generated/operations";
import { asyncThrow } from "@justworkshr/fe-utility-kit";

export type NeonSkyFFValueTypes = string | number | boolean | object;

export type NeonSkyFFContextType = {
  featureFlags: NeonSkyFeatureFlags;
};

export enum NeonSkyFeatureFlag {
  ACCOUNT_SETTINGS = "neonmoose_global_view_account_settings",
  BENEFITS_HEALTH_PLAN_SELECTION = "neonmoose_global_benefits_health_plan_selection",
  COMPANY_SETTINGS = "neonmoose_global_admin_company_settings",
  DIRECTORY = "neonmoose_global_directory",
  EOR_SOW_INVITE = "neonmoose_global_eor_sow_invite",
  INVOICES = "neonmoose_global_invoices",
  MANAGE_EMPLOYEES = "neonmoose_global_manage_employees",
  MORE_SERVICES = "neonmoose_global_more_services",
  VOUCHERS = "neonmoose_global_vouchers",
  W4_EXEMPTION_RENEWAL = "neonmoose_global_w4_exemption_renewal",
  ELECTRIC_AI_INTEGRATION = "neonmoose_global_electric_ai_integration",
  EOR_ONBOARDING = "neonmoose_global_eor_onboarding",
  INTERNATIONAL_PDP = "neonmoose_global_international_pdp",
  TIME_OFF_MEMBER_PROFILE = "neonmoose_global_time_off_member_profile",
  PERMIT_EOR_IN_PERSONAL_INFORMATION = "neonmoose_global_permit_eor_in_personal_information",
  PERMIT_EOR_IN_JOB_INFORMATION = "neonmoose_global_permit_eor_in_job_information",
  PERMIT_ADMIN_JOB_INFORMATION = "neonmoose_global_admin_member_job_information",
  PERMIT_ADMIN_PERSONAL_INFORMATION = "neonmoose_global_admin_member_settings",
  GLOBAL_NEW_NAV = "neonmoose_global_new_nav",
}

type NeonSkyFeatureFlags = {
  [key in NeonSkyFeatureFlag]: NeonSkyFFValueTypes;
};

export const NeonSkyContext = createContext<NeonSkyFFContextType>({
  featureFlags: {} as NeonSkyFeatureFlags,
});

export const NeonSkyProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const queryResult = useGetAllFeatureFlagsQuery();
  const { data, loading, error } = queryResult;

  if (error) {
    asyncThrow(
      `An error occurred while fetching feature flags: ${error.message}`
    );
  }

  if (loading || !data) {
    return <></>;
  }

  const featureFlags = data.allFeatureFlags as NeonSkyFeatureFlags;

  return (
    <NeonSkyContext.Provider value={{ featureFlags }}>
      {children}
    </NeonSkyContext.Provider>
  );
};
